export const SUBMIT_CLAIM_REQUEST = "SUBMIT_CLAIM_REQUEST";
export const SUBMIT_CLAIM_SUCCESS = "SUBMIT_CLAIM_SUCCESS";
export const SUBMIT_CLAIM_ERROR = "SUBMIT_CLAIM_ERROR";
